import React, { FC } from 'react';
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
} from '@mui/material';

interface InputFieldProps {
  id: string;
  name: string;
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
}

const InputField: FC<InputFieldProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  error,
  touched,
  disabled = false,
}) => {
  return (
    <FormControl fullWidth error={Boolean(error && touched)}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <OutlinedInput
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        label={label}
        error={Boolean(error && touched)}
      />
      {touched && error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default InputField;
